import { setFouls, setFoulsOnPeriod, setGoals } from 'modules/stream/store/game-info/game-info';
import { setPeriod, setState, setTimer, toggleTimer } from '../../store/time/time';

import { AppDispatch } from 'store/store';
import { setActiveBoard } from 'modules/template-editor/store/templates/templates';
import { setPopupIsLoaded } from '../../store/overlay/overlay';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

export interface PopupMessage {
  type: string;

  [key: string]: any;
}

export function useParsePopupMessage() {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    window.addEventListener('message', receiveMessage, false);

    function receiveMessage(event: MessageEvent) {
      const domain = window.location.origin;
      if (!event.origin.includes(domain)) return;

      try {
        const message: PopupMessage = JSON.parse(event.data);
        switch (message.type) {
          case 'changeBoard': {
            dispatch(setActiveBoard({ id: message.boardId }));
            break;
          }

          case 'setGoals': {
            dispatch(setGoals({ first: message?.first, second: message?.second }));
            break;
          }

          case 'setFouls': {
            dispatch(setFoulsOnPeriod({ first: message?.first, second: message?.second, period: message?.period }));
            break;
          }

          case 'setPeriod': {
            dispatch(setTimer({ milliseconds: 0 }));
            dispatch(setPeriod(message.period));
            break;
          }

          case 'toggleTimer': {
            dispatch(toggleTimer());
            break;
          }

          case 'setTimer': {
            dispatch(setTimer({ milliseconds: message.milliseconds }));
            break;
          }

          case 'syncState': {
            dispatch(setGoals(message.gameInfo.goals));
            dispatch(setFouls({ ...message.gameInfo.fouls, period: message.time.period }));
            dispatch(setState({ ...message.time, passedTime: message.timer }));
            break;
          }

          case 'popupLoaded': {
            dispatch(setPopupIsLoaded(true));
          }
        }
      } catch (e) {
        console.error(e, { data: event.data });
      }
    }
  }, [dispatch]);
}
